import { OnInit } from '@angular/core';
import { Environment } from '../environment/environment';
import { MaintenanceService } from '../../services/maintenance/maintenance-service';
import { OcapiService } from '../../services/ocapi/ocapi.service';
import { TvShopStateService } from '../../services/state/tv-shop-state.service';
import { ProductTypeRenditionEnum } from '../../constants/renditions/product-type-rendition.constants';
var TvshopHeaderComponent = /** @class */ (function () {
    function TvshopHeaderComponent(maintenanceService, ocapiService, stateService) {
        this.maintenanceService = maintenanceService;
        this.ocapiService = ocapiService;
        this.stateService = stateService;
        this.StreamingBundleProductTypeRendition = ProductTypeRenditionEnum.streamingBundle;
        this.clockTime = new Date();
        this.showTvShopHeader = true;
    }
    TvshopHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.utcTime();
        this.currentBrowserAddress = window.location.href;
        this.maintenanceService.getMaintenanceMode().subscribe(function (config) {
            _this.maintenanceModeConfig = config;
            _this.isThereMaintenancePlanned = config.isPlanned();
        });
        this.stateService.isTrailerPlaying$.subscribe(function (trailerPlaying) {
            _this.showTvShopHeader = !trailerPlaying;
        });
    };
    TvshopHeaderComponent.prototype.utcTime = function () {
        var _this = this;
        setInterval(function () {
            _this.clockTime = new Date();
        }, 1000);
    };
    Object.defineProperty(TvshopHeaderComponent.prototype, "shouldDisplayCurrentBrowserAddress", {
        get: function () {
            return 'dvp' === Environment.getCurrentEnvironment()
                || 'edp' === Environment.getCurrentEnvironment()
                || 'uat' === Environment.getCurrentEnvironment()
                || 'local' === Environment.getCurrentEnvironment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TvshopHeaderComponent.prototype, "currentDtvIdentifier", {
        get: function () {
            return this.ocapiService.getDtvIdentifier();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TvshopHeaderComponent.prototype, "currentCustomer", {
        get: function () {
            return this.ocapiService.getCustomerNumber();
        },
        enumerable: true,
        configurable: true
    });
    return TvshopHeaderComponent;
}());
export { TvshopHeaderComponent };
